export default (data, cluster) => {
  return data.filter(item => item.cluster === 'all' || item.cluster === cluster)
}
